module.exports = __webpack_public_path__ + "static/assets/0d3d508f0dd4328f014a78487b19308b.svg";